const S3_URL =
  "https://vws-front-store.s3.ap-northeast-2.amazonaws.com/landing/companies/";

export const CompanySection = () => {
  const companies = [
    { src: S3_URL + "sk-intellix.webp", alt: "sk intellix" },
    { src: S3_URL + "samcheonli.webp", alt: "삼천리" },
    { src: S3_URL + "cncity.webp", alt: "CNCITY" },
    { src: S3_URL + "carrier.webp", alt: "캐리어에어컨" },
    { src: "/assets/companies/sk-dnd.webp", alt: "SK D&D" },
    { src: "/assets/companies/dongsan.webp", alt: "계명대학교 동산병원" },
  ];

  return (
    <section className="flex flex-col gap-[32px] items-center px-[16px] py-[80px] tablet:px-[32px] bg-[#283241]">
      <div className="flex flex-col gap-[8px] text-center">
        <div className="text-heading-1-mb text-white desktop:text-heading-1">
          큰 기업들과도 함께 하고 있어요
        </div>
        <div className="text-body-2-mb text-white desktop:text-body-1">
          <div>대기업부터 중견 중소기업들까지,</div>
          <div>기업들도 매월 몇천건씩 채권도시에 위임을 하고 있습니다</div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-[24px] desktop:grid-cols-3 w-full desktop:w-fit">
        {companies.map((company) => (
          <div
            key={company.alt}
            className="flex items-center justify-center rounded-[12px] bg-white w-full max-w-[328px] py-6 mx-auto desktop:w-[364px]"
          >
            <img
              src={company.src}
              alt={company.alt}
              loading="lazy"
              decoding="async"
              className="w-[200px] h-[100px] object-contain"
            />
          </div>
        ))}
      </div>
    </section>
  );
};
